<template>
    <section class="pois-height">
      <!-- You can add a loading spinner if needed -->
      <div class="container">
        <div class="row">
          <div class="col-12 title py-3">
            <h2 class="align-self-center text-center">{{ $t('vineyards.title') }}</h2>
          </div>
          <hr>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 mb-4" v-for="(vineyard, index) in vineyardList" :key="index">
            <div class="vineyard-card">
              <div v-if="activeViewer === index" class="viewer" :id="'viewer-' + index"></div>
              <img
                v-else
                :src="vineyard.images360[0]"
                class="static-preview"
                @click="activateViewer(index)"
                style="width: 100%; height: 340px; object-fit: cover; border-radius: 24px 24px 0 0; cursor: pointer; position: relative;"
                :alt="vineyard.name + ' 360 preview'"
              />
              <div
                v-if="activeViewer !== index"
                class="click-overlay"
                @click="activateViewer(index)"
                style="position: absolute; top: 0; left: 0; width: 100%; height: 340px; display: flex; flex-direction: column; align-items: center; justify-content: center; border-radius: 24px 24px 0 0; background: rgba(0,0,0,0.28); color: #fff; font-size: 1.2rem; font-weight: 600; pointer-events: none; z-index: 2;"
              >
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-bottom: 0.5rem;">
                  <path d="M12 2a10 10 0 1 0 10 10" stroke="currentColor" stroke-width="2" fill="none"/>
                  <path d="M22 2v6h-6" stroke="currentColor" stroke-width="2" fill="none"/>
                </svg>
                <span>{{ isTouchDevice ? $t('vineyards.tapToExplore') : $t('vineyards.clickToExplore') }}</span>
              </div>
              <div class="card-bottom">
                <div class="vineyard-title">{{ vineyard.name }}</div>
                <button class="explore-btn" @click="goToDetails(vineyard)">{{ $t('vineyards.explore') }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  import { Viewer } from 'photo-sphere-viewer';
  import 'photo-sphere-viewer/dist/photo-sphere-viewer.css';
  import vineyardList from '@/data/vineyards.json';

  export default {
    name: "Vineyards",
    data() {
      return {
        vineyardList: vineyardList,
        viewers: [],
        activeViewer: null
      }
    },
    computed: {
      isTouchDevice() {
        return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      }
    },
    mounted() {
      // No viewers initialized by default
    },
    beforeDestroy() {
      this.viewers.forEach(viewer => viewer && viewer.destroy());
    },
    methods: {
      activateViewer(index) {
        // Destroy previous viewer if any
        if (this.activeViewer !== null && this.viewers[this.activeViewer]) {
          this.viewers[this.activeViewer].destroy();
          this.viewers[this.activeViewer] = null;
        }
        this.activeViewer = index;
        this.$nextTick(() => {
          const viewer = new Viewer({
            container: document.getElementById('viewer-' + index),
            panorama: this.vineyardList[index].images360[0],
            navbar: false,
            defaultLong: '0deg',
            defaultLat: '0deg',
            defaultZoomLvl: 0,
            size: { width: '100%', height: 340 }
          });
          this.viewers[index] = viewer;
        });
      },
      goToDetails(vineyard) {
        this.$router.push({ name: 'TravelPathsDetail', params: { slug: vineyard.slug } });
      }
    }
  }
  </script>
  
  <style scoped>
  .pois-height {
    min-height: 100vh;
  }
.title h2 {
    margin: 0;
    font-weight: bold !important;
}
hr {
    opacity: 1 !important;
    background-color: transparent;
    border: 1px solid black !important;
    margin-bottom: 1rem;
}
.vineyard-card {
  background: #f8f8f8;
  border-radius: 24px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.10), 0 1.5px 6px rgba(0,0,0,0.08);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: transform 0.2s, box-shadow 0.2s;
  min-height: 420px;
  position: relative;
}
.viewer {
  width: 100%;
  aspect-ratio: 16/9;
  min-height: 220px;
  background: #e0e0e0;
  border-radius: 24px 24px 0 0;
  overflow: hidden;
}
.card-bottom {
  background: #DDB427;
  padding: 1rem;
  text-align: center;
  border-radius: 0 0 24px 24px;
  font-size: 1.4rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-shadow: 0 2px 8px rgba(0,0,0,0.3);
  margin-top: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}
.vineyard-title {
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  letter-spacing: 0.04em;
  text-shadow: 0 2px 8px rgba(0,0,0,0.3);
}
.explore-btn {
  background: #fff;
  color: #ddb427;
  border: none;
  border-radius: 24px;
  padding: 0.7rem 2.2rem;
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  cursor: pointer;
  outline: none;
  box-shadow: 0 2px 8px rgba(0,0,0,0.10);
  transition: background 0.2s, color 0.2s;
}
.explore-btn:hover {
  background: #f5f5f5;
}
.click-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 340px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 24px 24px 0 0;
  background: rgba(0,0,0,0.28);
  color: #fff;
  font-size: 1.2rem;
  font-weight: 600;
  pointer-events: none;
  z-index: 2;
  text-shadow: 0 2px 8px rgba(0,0,0,0.5);
}

@media (max-width: 768px) {
  .vineyard-card {
    min-height: 320px;
    border-radius: 16px;
  }
  .viewer {
    border-radius: 16px 16px 0 0;
    min-height: 140px;
  }
  .card-bottom {
    border-radius: 0 0 16px 16px;
    font-size: 1.1rem;
    padding: 1rem 0.5rem 0.8rem 0.5rem;
  }
}
  </style>